import React, { memo, useCallback, useState } from 'react'

import { AIGenerated2, Button, Icon, Verified } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { func } from 'prop-types'

import useApiPost from 'Pods/Shared/Hooks/useApiPost'
import useTranslation from 'Pods/ThreeDStudio/Hooks/useTranslation'
import { setAvailableCredits } from 'Pods/ThreeDStudio/Store/actions/generation'
import {
  setMonthlyGenerationsAvailable,
  setMonthlyGenerationsUsed,
  setStudioAccessTier,
} from 'Pods/ThreeDStudio/Store/actions/subscription'
import { STUDIO_ACCESS_TIER } from 'Pods/ThreeDStudio/Store/constants'

const FREE_BETA_ENROLL_PATH = '/api/internal/generator/free-trial'

function FreeBetaCard({ onClose: handleClose }) {
  const t = useTranslation()
  const { postData, isLoading } = useApiPost()
  const [hasEnrolled, setHasEnrolled] = useState(false)

  const handleClick = useCallback(() => {
    if (isLoading || hasEnrolled) {
      return
    }

    postData({
      path: FREE_BETA_ENROLL_PATH,
      data: {},
      onSuccess: (response) => {
        const data = response?.data?.data || {}
        const tier = data.studioAccessTier || STUDIO_ACCESS_TIER.IN_FREE_BETA
        const monthlyAvailable = typeof data.monthlyGenerationsAvailable === 'number'
          ? data.monthlyGenerationsAvailable
          : 5
        const monthlyUsed = typeof data.monthlyGenerationsUsed === 'number'
          ? data.monthlyGenerationsUsed
          : 0

        setStudioAccessTier(tier, data.premiumFeatures)
        setMonthlyGenerationsAvailable(monthlyAvailable)
        setMonthlyGenerationsUsed(monthlyUsed)
        if (typeof data.availableCredits === 'number') {
          setAvailableCredits(data.availableCredits)
        }
        setHasEnrolled(true)
        window.showNotification(t('usageModal.freeBetaCard.successMessage'), { type: 'success', autohide: true })
        handleClose()
      },
      onError: () => {
        window.showNotification(t('usageModal.freeBetaCard.errorMessage'), { type: 'error', autohide: true })
      },
    })
  }, [postData, isLoading, hasEnrolled, handleClose, t])

  return (
    <section className="usage-modal__card usage-modal__card--beta">
      <div className="usage-modal__card-chip cgt-caption-semibold usage-modal__card-chip--beta">
        {t('usageModal.freeBetaCard.chip')}
      </div>

      <div className="usage-modal__price">
        <span className="cgt-heading-300">$0</span>
      </div>

      <ul className="usage-modal__bullets">
        <li className="usage-modal__bullet">
          <Icon
            svgComponent={Verified}
            color="primary"
            size="small"
            notSpaced
            className="usage-modal__bullet-icon"
          />
          <span className="cgt-body-base">
            <span className="cgt-body-md-semibold">{t('usageModal.freeBetaCard.freeGenerations')}</span>
            {t('usageModal.freeBetaCard.inStudio')}
          </span>
        </li>
        <li className="usage-modal__bullet">
          <Icon
            svgComponent={Verified}
            color="primary"
            size="small"
            notSpaced
            className="usage-modal__bullet-icon"
          />
          <span className="usage-modal__bullet-text cgt-body-base">
            {t('usageModal.freeBetaCard.noCreditCard')}
          </span>
        </li>
        <li className="usage-modal__bullet-divider" aria-hidden="true" />
        <li className="usage-modal__bullet">
          <Icon
            svgComponent={AIGenerated2}
            color="primary"
            size="small"
            notSpaced
            className="usage-modal__bullet-icon"
          />
          <span className="usage-modal__bullet-text cgt-body-base">{t('usageModal.freeBetaCard.gettingStarted')}</span>
        </li>
      </ul>

      <div className="usage-modal__card-footer">
        <Button
          size="small"
          type="secondary"
          onClick={handleClick}
          disabled={isLoading || hasEnrolled}
        >
          {isLoading ? t('usageModal.freeBetaCard.starting') : t('usageModal.freeBetaCard.cta')}
        </Button>
      </div>
    </section>
  )
}

FreeBetaCard.propTypes = {
  onClose: func.isRequired,
}

export default memo(FreeBetaCard)
